import React from 'react';
import Table from '../Table';
/**
 * プレビュー画面コンテンツのBase Interface
 */
export interface PreviewBaseProps {
  // タイトル
  title: string;
  // ユニークキー(data-testid,data-testid-e2e)に付与する文字列
  uniqueId: string;
}

/**
 * プレビュー画面メインコンテンツ表示のProps定義
 */
export interface PreviewContentsProps extends PreviewBaseProps {
  // 値を単純に表示したい場合に設定します(pタグに値が表示されます)
  paragraphValue?: string;
  // ネストしてコンポーネントを表示したい場合に設定します
  children?: React.ReactNode;
}

/**
 * プレビュー画面 値表示用コンポーネント
 *
 * ※必ずTableタグ内で使用して下さい
 */
const PreviewContents = ({ title, uniqueId, paragraphValue, children }: PreviewContentsProps) => {
  return (
    <Table.Tr>
      <Table.Td className='preview-table__label' data-testid={`${uniqueId}-label`} data-testid-e2e={`${uniqueId}-label`}>
        <p>{title}</p>
      </Table.Td>
      <Table.Td className='preview-table__value' data-testid={`${uniqueId}-value`} data-testid-e2e={`${uniqueId}-value`}>
        {paragraphValue ? <p>{paragraphValue}</p> : children || <></>}
      </Table.Td>
    </Table.Tr>
  );
};

export default PreviewContents;
